import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';

export type StatusKind = 'info' | 'success' | 'warning' | 'error' | 'offline';

const icons: Record<StatusKind, IconName> = {
  info: 'info',
  success: 'check-circle',
  warning: 'warning',
  error: 'error',
  offline: 'offline',
};

interface StatusBannerProps {
  kind: StatusKind;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}

/** Errors interrupt assistive tech (role=alert); everything else is announced politely. */
export function StatusBanner({ kind, title, children, action }: StatusBannerProps) {
  return (
    <div className={`status status--${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      <span className="status__icon">
        <Icon name={icons[kind]} />
      </span>
      <div className="stack" style={{ gap: 'var(--sp-1)', flex: 1 }}>
        <p className="status__title">{title}</p>
        {children && <div>{children}</div>}
        {action && <div className="cluster">{action}</div>}
      </div>
    </div>
  );
}
